export enum BuildAction {
  None = 'none',
  ApiRedirect = 'api_redirect',
  ForceUpdate = 'force_update',
}
